import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { saveTokens, clearTokens } from "./api";
import { relinkDevice, unlinkDevice } from "./native";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // null = checking, false = anonymous, object = user
  const [user, setUser] = useState(null);

  const checkSession = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      relinkDevice((path, body) => api.post(path, body));
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    checkSession();
  }, [checkSession]);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    saveTokens(data);
    setUser(data);
    relinkDevice((path, body) => api.post(path, body));
    return data;
  }, []);

  const logout = useCallback(async () => {
    await unlinkDevice((path, body) => api.post(path, body));
    try {
      await api.post("/auth/logout");
    } catch {}
    clearTokens();
    setUser(false);
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout, refresh: checkSession }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
  return ctx;
}
